/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDInput
import MDInputRoot from "components/MDInput/MDInputRoot";
import { FormControl, FormHelperText,} from "@mui/material";
import { InputLabel } from '@mui/material';
import MDTypography from "components/MDTypography";
const MDInput = forwardRef(
  (
    {
      formError,
      error,
      label,
      size,
      id,
      type,
      value,
      name,
      onBlur,
      onChange,
      InputProps,
      endAdornment,
      sx,
      formSx,
      success,
      disabled,
    },
    ref
  ) => (
    <>
      <FormControl fullWidth error={formError} sx={formSx}>
    <MDTypography fontSize='xs' pb={1} pl={0.5}>{label}</MDTypography>
        <MDInputRoot
          ref={ref}
          size={size}
          id={id}
          type={type}
          value={value}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          endAdornment={endAdornment}
          sx={sx}
        />
        {formError && (
          <FormHelperText  error id="standard-weight-helper-text-email-login">
            {error}
          </FormHelperText>
        )}
      </FormControl>
    </>
  )
);

// const MDInput=({rest})=>{
//   return(

//       <OutlinedInput {...rest}  />

//   )
// }
// Setting default values for the props of MDInput
MDInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
};

// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MDInput;
